<script lang="ts">
import "@cisco-u/modal/cu-modal.js";

import { defineComponent } from "vue";

import { sendButtonCtaTelemetry } from "@/utils/ctaTelemetry";
import isUnauth from "@/utils/isUnauth";

export default defineComponent({
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showFeedback: false,
    };
  },
  methods: {
    isUnauth,
    async showFeedbackModal() {
      await sendButtonCtaTelemetry(
        this.$route.fullPath,
        "Feedback",
        this.isUnauth()
      );
      this.showFeedback = !this.showFeedback;
    },
    closeFeedbackModal() {
      this.showFeedback = false;
    },
  },
});
</script>

<template>
  <div>
    <div class="fixed right-0 top-1/2 z-[9999999] h-28 w-28">
      <button
        class="btn -rotate-90 bg-blue-light text-white-lightest"
        @click.prevent="showFeedbackModal"
        @keyup.enter.prevent="showFeedbackModal"
        @keyup.space.prevent="showFeedbackModal"
        data-cy="feedback-btn"
      >
        Feedback
      </button>
    </div>
    <cu-modal
      v-if="showFeedback"
      class="feedback-modal"
      type="small"
      width="50rem"
      :open="showFeedback"
      data-cy="feedback-modal"
      @modalResponse="closeFeedbackModal"
    >
      <div slot="header" class="px-4 text-22 font-light text-white-lightest">
        Feedback
      </div>
      <div slot="body" class="p-4">
        <iframe
          :src="url"
          class="h-[37.5rem] w-full border-0"
          title="Feedback survey"
        ></iframe>
      </div>
    </cu-modal>
  </div>
</template>
